import React from "react";
import { cn } from "@/lib/utils";
import { money, num as fmtNum } from "@/lib/sk";

const base = "h-8 w-full rounded-md border bg-white px-2 text-[12.5px] outline-none transition-colors focus:border-primary/60 focus:ring-2 focus:ring-primary/15 disabled:border-transparent disabled:bg-transparent disabled:px-0";

/** Numeric field. Empty = unknown (null) – never 0. Read mode shows the formatted value or a labelled «ukjent». */
export function NumField({ value, onChange, editing, error, testId, unknownLabel = "ukjent", suffix, className, align = "right", placeholder }) {
  if (!editing) {
    return <span className={cn("font-mono text-[12.5px] tabular-nums", value == null && "text-muted-foreground/70 italic", className)} data-testid={testId}>{value == null ? unknownLabel : `${fmtNum(value, 2).replace(/,00$/, "")}${suffix || ""}`}</span>;
  }
  return (
    <input value={value ?? ""} inputMode="decimal" placeholder={placeholder || unknownLabel} onChange={(e) => onChange(e.target.value === "" ? null : e.target.value)} className={cn(base, "font-mono", align === "right" && "text-right", error ? "border-[hsl(var(--v-blocked))] ring-2 ring-[hsl(var(--v-blocked)/0.15)]" : "border-black/[0.1]", className)} data-testid={testId} aria-invalid={Boolean(error)} title={error || undefined} />
  );
}

export function TextField({ value, onChange, editing, error, testId, className, placeholder, mono }) {
  if (!editing) return <span className={cn("text-[12.5px]", mono && "font-mono", !value && "text-muted-foreground/60", className)} data-testid={testId}>{value || "–"}</span>;
  return <input value={value ?? ""} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} className={cn(base, mono && "font-mono", error ? "border-[hsl(var(--v-blocked))]" : "border-black/[0.1]", className)} data-testid={testId} aria-invalid={Boolean(error)} title={error || undefined} />;
}

export function SelectField({ value, onChange, editing, options, testId, className, display }) {
  if (!editing) return <span className={cn("text-[12.5px]", className)} data-testid={testId}>{display ?? (options.find(([v]) => v === value)?.[1] || value || "–")}</span>;
  return (
    <select value={value ?? ""} onChange={(e) => onChange(e.target.value)} className={cn(base, "border-black/[0.1]", className)} data-testid={testId}>
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  );
}

export function Money({ v, className, testId }) {
  return <span className={cn("font-mono text-[12.5px] tabular-nums", v == null && "text-muted-foreground/70 italic", className)} data-testid={testId}>{v == null ? "ukjent" : money(v, "NOK", 1, { bare: true })}</span>;
}

export function Pct({ v, className, testId, label }) {
  return <span className={cn("font-mono text-[12px] tabular-nums", v == null && "text-muted-foreground/60", className)} data-testid={testId}>{v == null ? "–" : `${fmtNum(v, 1)} %`}{label ? <span className="ml-1 text-[10.5px] font-sans text-muted-foreground">{label}</span> : null}</span>;
}
